import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ButtonComp from "../../components/ButtonComp";
import { Loader, No_data } from "../../utils/utils";
import { get_i_rejected_list } from "../../redux/slice/indentSlice";

const Reject = () => {
  const dispatch = useDispatch();
  const { reject_list, reject_loading } = useSelector((state) => state.indents);
  useEffect(() => {
    dispatch(get_i_rejected_list());
  }, []);
  return (
    <div>
      {reject_list.length == 0 && reject_loading ? (
        <div className="card p20 df alc jcc">
          <Loader />
        </div>
      ) : reject_list.length == 0 ? (
        <No_data />
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: window.matchMedia("(max-width: 500px)").matches
              ? "repeat(1, 1fr)"
              : window.matchMedia("(max-width: 900px)").matches
              ? "repeat(2, 1fr)"
              : "repeat(3, 1fr)",
            gridGap: 20,
          }}
        >
          {reject_list.map((v, i) => (
            <div className={"card p20"} key={i}>
              <div style={{ justifyContent: "space-between", display: "flex" }}>
                <div className="fs16 fw600 black pb6">{v.description}</div>
                <div className="fs14 fw600 orange">{v.indentid}</div>
              </div>

              <div className="df alc gap20 pb6">
                <div className="df alc gap10 ">
                  <div className="fs14 fw400 black">Price:</div>
                  <div className="fs14 fw400 black">{v.price}</div>
                </div>
                <div className="df alc gap10 ">
                  <div className="fs14 fw400 black">Quantity:</div>
                  <div className="fs14 fw400 black">{v.quantity}</div>
                </div>
              </div>
              <div className="df alc gap10 pb6">
                <div className="fs14 fw400 black">Address :</div>
                <div className="fs14 fw400 black">{v.deliveryaddress}</div>
              </div>
              <div className="df alc gap10 pb6">
                <div className="fs14 fw400 black">Datetime:</div>
                <div className="fs14 fw400 black">{v.created_at}</div>
              </div>
              <div className="df alc gap10 pb6">
                <div className="fs14 fw400 black">Amount:</div>
                <div className="fs14 fw400 view">{v.totalamount}</div>
              </div>
              <div className="df alc gap10 pb6">
                <div className="fs14 fw400 black">Message:</div>
                <div className="fs14 fw400 black">{v.message}</div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Reject;
